import { userListResponseSchema, type User } from '@chatapp-inbox/shared';
import { request } from './http';

/** Todos os usuários. SÓ ADMINISTRADOR (atendente recebe 403): usado para transferir conversas. */
export async function listUsers(signal?: AbortSignal): Promise<User[]> {
  const { users } = await request('/admin/users', {
    schema: userListResponseSchema,
    ...(signal ? { signal } : {}),
  });
  return users;
}
